var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSocialStyle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 256,
    height: 256,
    viewBox: "0 0 67.733 67.733",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M17.67 24.379H37.041V41.388000000000005H17.67z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-5.197 5.67H23.157V26.950000000000003H-5.197z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.197 9.449H11.812000000000001V35.246H5.197z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeDasharray: "none",
    strokeMiterlimit: 4,
    strokeOpacity: 1
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 1,
    stroke: "#000",
    strokeLinecap: "butt",
    strokeLinejoin: "round",
    strokeWidth: 0.4,
    d: "M11.343 26.974C5.316 28.64.63 35.814 3.976 43.996c4.868 11.9 24.394 16.667 24.394 16.667s14.528-13.892 12.793-26.632c-1.734-12.74-17.122-15.136-21.4-5.492-2.665-1.941-5.68-2.322-8.42-1.565zm18.121 3.68l3.37 12.574 2.319-.622c.553-.148.974-.145 1.264.01.295.145.489.39.58.733.09.336.045.645-.136.925-.175.272-.54.481-1.093.63l-6.936 1.858c-.553.148-.977.15-1.272.005-.29-.155-.48-.404-.573-.748-.09-.336-.047-.64.129-.91.18-.281.547-.496 1.1-.644l2.32-.622-2.567-9.582-1.907 1.088c-.305.178-.54.289-.704.333-.291.078-.576.03-.855-.144a1.267 1.267 0 01-.542-.768c-.082-.306-.067-.565.043-.78.11-.22.396-.466.86-.735zM15.026 36.48c.344-.092.652-.047.925.136.28.174.493.537.64 1.09l1.016 3.836 3.284-.88c.553-.148.973-.149 1.261-.002.295.146.489.39.581.734a1.12 1.12 0 01-.133.936c-.176.272-.54.481-1.093.63l-3.284.88 1.03 3.843c.149.553.15.977.005 1.273-.148.287-.393.477-.737.569-.343.092-.654.051-.933-.122-.273-.183-.484-.55-.632-1.104l-1.03-3.844-3.284.88c-.552.148-.976.15-1.271.004-.29-.154-.481-.403-.573-.747-.092-.343-.05-.652.125-.923.181-.28.549-.491 1.104-.632l3.283-.88-1.027-3.832c-.146-.546-.146-.966-.001-1.261.153-.298.4-.492.744-.584z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 1,
    stroke: "none",
    strokeDashoffset: 37.795,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M51.2 3.407a14.553 10.33 10.114 00-16.125 7.616 14.553 10.33 10.114 0012.513 12.724 14.553 10.33 10.114 002.795.302c.424.7 1.426 1.913 3.68 3.064 3.877 1.98 6.125.024 6.125.024s-2.064-.807-3.569-2.265a4.03 4.03 0 01-.918-1.378 14.553 10.33 10.114 008.029-7.36A14.553 10.33 10.114 0051.216 3.41a14.553 10.33 10.114 00-.016-.003z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 1,
    stroke: "#000",
    strokeLinecap: "butt",
    strokeLinejoin: "round",
    strokeWidth: 0.4,
    d: "M42.6 49.209c.981-6.71 9.113-7.893 11.32-2.783 4.53-3.232 10.878 1.986 8.248 8.237-2.63 6.25-12.958 8.661-12.958 8.661S41.617 55.92 42.6 49.21z"
  }), /*#__PURE__*/React.createElement("g", {
    strokeWidth: 1.251,
    transform: "matrix(.79907 0 0 .79907 -23.54 19.141)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 57.663,
    cy: -17.707,
    r: 4.076,
    fill: "#000",
    fillOpacity: 1,
    stroke: "none",
    strokeDashoffset: 37.795,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.503
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40.558,
    cy: -8.085,
    r: 4.076,
    fill: "#000",
    fillOpacity: 1,
    stroke: "none",
    strokeDashoffset: 37.795,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.503
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 61.004,
    cy: -0.601,
    r: 4.076,
    fill: "#000",
    fillOpacity: 1,
    stroke: "none",
    strokeDashoffset: 37.795,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.503
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeWidth: 3.754,
    d: "M57.663-17.707L40.558-8.085 61.004-.6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialStyle);
export default __webpack_public_path__ + "static/media/social_style.2cef84e1c99384c76c5b7faad91ceda4.svg";
export { ForwardRef as ReactComponent };